<template>
  <section class="col6-big-img p-lg">
    <div class="col6-wrap">
      <h2 v-if="titleHtml" class="col6-title m-b tt-up col6-title-html" v-html="titleHtml"></h2>
      <h2 v-else-if="title" class="col6-title m-b tt-up">{{ title }}</h2>
      <div class="col6-grid g-lg">
        <div class="col6-big-img-field col6-reviewers-field" :style="{ backgroundColor: imageBgColor }">
          <div class="col6-img-gradient"></div>
          <div class="col6-img-inner col6-reviewers-inner">
            <h2 v-if="sectionTitle" class="col6-reviewers-section-title tt-up">{{ sectionTitle }}</h2>
            <div class="col6-reviewers-row">
              <div
                v-for="(card, index) in cards"
                :key="card.id != null ? card.id : index"
                class="col6-reviewer-card col6-reviewer-card--clickable"
                :class="{ 'col6-reviewer-card--selected': (card.id || card.name) === activeId }"
                role="button"
                tabindex="0"
                @click="activeId = card.id || card.name"
                @keydown.enter.prevent="activeId = card.id || card.name"
                @keydown.space.prevent="activeId = card.id || card.name"
              >
                <div class="col6-reviewer-card-avatar-wrap">
                  <div class="col6-reviewer-card-avatar">
                    <img
                      v-if="card.image"
                      :src="card.image"
                      :alt="card.name"
                      class="col6-reviewer-card-img"
                    />
                  </div>
                  <div v-if="(card.id || card.name) === activeId" class="col6-reviewer-card-check">
                    <IconBase w="15" h="15" color="#121212" viewBox="0 0 15 15">
                      <IconCheck />
                    </IconBase>
                  </div>
                </div>
                <p v-if="card.name" class="col6-reviewer-card-name tt-up">{{ card.name }}</p>
                <p v-if="card.role" class="col6-reviewer-card-role tt-up">{{ card.role }}</p>
              </div>
              <div
                v-if="showAddCard"
                class="col6-reviewer-card col6-reviewer-card--add"
                role="button"
                @click="$emit('add-reviewer')"
              >
                <div class="col6-reviewer-card-add-circle">
                  <IconBase w="15" h="15" viewBox="0 0 15 15">
                    <IconPlus />
                  </IconBase>
                </div>
                <p class="col6-reviewer-card-add-label tt-up">ADD REVIEWER</p>
              </div>
            </div>
            <router-link
              v-if="manageProfilesTo && manageProfilesText"
              :to="manageProfilesTo"
              class="col6-reviewers-manage-btn tt-up"
            >
              {{ manageProfilesText }}
            </router-link>
            <!-- <button
              v-else-if="manageProfilesText"
              type="button"
              class="col6-reviewers-manage-btn tt-up"
              @click="$emit('manage-profiles')"
            >
              {{ manageProfilesText }}
            </button> -->
          </div>
        </div>
        <div class="col6-text-field b-top p-t">
          <p v-if="rightTitle" class="col6-right-title tt-up m-b">{{ rightTitle }}</p>
          <p v-if="rightParagraph" class="col6-right-para m-b mute" v-html="rightParagraph"></p>
          <ul v-if="checklist.length" class="col6-checklist">
            <li
              v-for="(item, i) in checklist"
              :key="i"
              class="col6-checklist-item"
            >
              <IconBase
                w="15"
                h="15"
                :color="checkIconColor"
                class="col6-check-icon"
              >
                <IconCheck />
              </IconBase>
              <span>{{ item }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import IconBase from '@/assets/icons/IconBase.vue'
import IconCheck from '@/assets/icons/IconCheck.vue'
import IconPlus from '@/assets/icons/IconPlus.vue'

export default {
  name: 'Col6BigReviewers',
  components: {
    IconBase,
    IconCheck,
    IconPlus,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    titleHtml: {
      type: String,
      default: '',
    },
    sectionTitle: {
      type: String,
      default: "WHO'S REVIEWING?",
    },
    imageBgColor: {
      type: String,
      default: '#121212',
    },
    cards: {
      type: Array,
      default: () => [
        {
          id: 'niklaz',
          name: 'Niklaz',
          role: 'Head of A&R',
          image: require('@/assets/img/features/avatars/Avatar-1.webp'),
        },
        {
          id: 'max',
          name: 'Max',
          role: 'Label Manager',
          image: require('@/assets/img/features/avatars/Avatar-2.webp'),
        },
        {
          id: 'anna',
          name: 'Anna',
          role: 'Curator',
          image: require('@/assets/img/features/avatars/Avatar-3.webp'),
        },
      ],
      validator: (arr) =>
        arr.every(
          (c) =>
            c && typeof c === 'object' && (c.name != null || c.role != null)
        ),
    },
    showAddCard: {
      type: Boolean,
      default: false,
    },
    manageProfilesText: {
      type: String,
      default: 'MANAGE PROFILES',
    },
    manageProfilesTo: {
      type: [String, Object],
      default: '',
    },
    avatarSize: {
      type: [String, Number],
      default: 56,
    },
    rightTitle: {
      type: String,
      default: '',
    },
    rightParagraph: {
      type: String,
      default: '',
    },
    checklist: {
      type: Array,
      default: () => [],
    },
    checkIconColor: {
      type: String,
      default: '#22c55e',
    },
  },
  data() {
    return { activeId: 'niklaz' }
  },
}
</script>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
@import "@/scss/_classes.scss";
@import "@/scss/_mixins.scss";

$reviewer-card-bg: #282828;
$reviewer-accent: #c8ff00;

.col6-big-img {
  @media #{$mobile} {
    padding: $mg-desktop-xl $mg-desktop;
  }
}

.col6-wrap {
  margin: 0 auto;
}

.col6-title {
  font-size: clamp(1.75rem, 4vw, 2.5rem);
  font-weight: 500;
  color: $white;
  line-height: 1.2;
}

.col6-title-html::v-deep .title-grey {
  color: $grey;
}

.col6-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  @media #{$mobile} {
    grid-template-columns: 1fr;
  }
}

.col6-big-img-field.col6-reviewers-field {
  grid-column: span 4;
  position: relative;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: $mg-desktop-lg;
  @media #{$mobile} {
    grid-column: 1;
    min-height: 320px;
    padding: $mg-desktop-xl $mg-desktop;
  }
}

.col6-img-gradient {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 30%;
  min-height: 80px;
  background: linear-gradient(to top, rgba(0, 0, 0, 1) 0%, transparent 100%);
  z-index: 2;
  pointer-events: none;
}

.col6-img-inner.col6-reviewers-inner {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
  background: transparent;
}

.col6-reviewers-section-title {
  margin: 0 0 $mg-desktop-xl 0;
  font-weight: 400;
  color: $white;
  text-align: center;
}

.col6-reviewers-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  gap: $mg-desktop;
  width: 100%;
  margin-bottom: $mg-desktop-xl;
  @media #{$mobile} {
    gap: $mg-desktop-sm;
    margin-bottom: $mg-desktop-lg;
  }
}

.col6-reviewer-card {
  background: $reviewer-card-bg;
  border: 1px solid transparent;
  border-radius: $border-radius-xl;
  padding: $mg-desktop-lg $mg-desktop;
  min-width: 140px;
  max-width: 160px;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  box-sizing: border-box;
  transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;

  &--clickable {
    cursor: pointer;
  }

  &:hover:not(.col6-reviewer-card--add):not(.col6-reviewer-card--selected) {
    background: lighten($reviewer-card-bg, 5%);
  }

  &--selected {
    border-color: $reviewer-accent;
    box-shadow: 0 0 16px rgba(200, 255, 0, 0.35);

    &:hover {
      background: lighten($reviewer-card-bg, 3%);
    }
  }

  &--add {
    cursor: pointer;
    justify-content: center;

    &:hover {
      background: lighten($reviewer-card-bg, 6%);
      .col6-reviewer-card-add-circle {
        border-color: #cccccc;
      }
    }
  }
}

.col6-reviewer-card-avatar-wrap {
  position: relative;
  margin-bottom: $mg-desktop;
}

.col6-reviewer-card-avatar {
  flex-shrink: 0;
  border-radius: 50%;
  overflow: hidden;
  width: 80px;
  height: 80px;
}

.col6-reviewer-card-img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.col6-reviewer-card-check {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: $reviewer-accent;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.col6-reviewer-card-name {
  color: $white;
}

.col6-reviewer-card-role {
  font-size: 0.6875rem;
  color: #a0a0a0;
}

.col6-reviewer-card-add-circle {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: 1px solid #aaaaaa;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: $mg-desktop;
  transition: border-color 0.2s ease;
}

.col6-reviewer-card-add-label {
  margin: 0;
  font-size: 0.6875rem;
  font-weight: 500;
  color: $white;
  letter-spacing: 0.02em;
}

.col6-reviewers-manage-btn {
  display: inline-block;
  padding: $mg-desktop $mg-desktop-xl;
  background: $reviewer-card-bg;
  color: $white;
  font-size: 0.8125rem;
  font-weight: 500;
  letter-spacing: 0.02em;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: $border-radius-pill;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease;
  &:hover {
    background: lighten($reviewer-card-bg, 6%);
    border-color: rgba(255, 255, 255, 0.4);
  }
}

.col6-text-field {
  grid-column: span 2;
  @media #{$mobile} {
    grid-column: 1;
    padding-top: 0;
    border: 0;
  }
}

.col6-checklist {
  list-style: none;
  margin: 0;
  padding: 0;
}

.col6-checklist-item {
  display: flex;
  align-items: flex-start;
  gap: $mg-desktop;
  margin-bottom: $mg-desktop;
  line-height: 1.4;
  color: $white;
  &:last-child {
    margin-bottom: 0;
  }
}

.col6-check-icon {
  flex-shrink: 0;
  margin-top: 2px;
}
</style>
